import { getDueWorkingDay } from '../../../../../../../../../../../../../lib/functions/dates';

export const calculatePaymentDates = (
  creditDetails: any,
  firstPaymentDate: Date,
  workingDayActive: 'active' | 'inactive',
  operationDate: Date,
) => {
  const paymentDates: any[] = [];

  const currentDate = new Date(firstPaymentDate);
  let quotaPaymentDate = new Date(firstPaymentDate);
  if (workingDayActive === 'active') {
    quotaPaymentDate = getDueWorkingDay(currentDate);
  }
  let diffDays = Math.floor(
    (quotaPaymentDate.getTime() - operationDate.getTime()) /
      (1000 * 60 * 60 * 24),
  );
  paymentDates.push({ date: new Date(quotaPaymentDate), diffDays: diffDays });

  for (let i = 1; i < creditDetails.months; i++) {
    const daysToAdd = calculateDateToAdd(creditDetails);
    console.log('daysToAdd', daysToAdd);
    // Dias oficiales de pago
    currentDate.setDate(currentDate.getDate() + daysToAdd);
    // Dia movible si no es día hábil
    quotaPaymentDate = new Date(currentDate);
    if (workingDayActive === 'active') {
      quotaPaymentDate = getDueWorkingDay(currentDate);
    }
    const lastEntry = paymentDates[i - 1];
    diffDays =
      (quotaPaymentDate.getTime() - lastEntry.date.getTime()) /
      (1000 * 60 * 60 * 24);
    paymentDates.push({ date: new Date(quotaPaymentDate), diffDays: diffDays });
  }

  return paymentDates;
};

export const calculateDateToAdd = (creditDetails: any) => {
  const daysSegment = creditDetails.periodicity;
  switch (daysSegment) {
    case 'WEEKLY':
      return 7;
    case 'BIWEEKLY':
      return 14;
    case 'MONTHLY':
      return 30;
    case 'BIMONTHLY':
      return 60;
    case 'QUARTERLY':
      return 90;
    case 'SEMI_ANNUAL':
      return 180;
    case 'ANNUAL':
      return 360;
    default:
      return 30;
  }
};
